module.exports = __webpack_public_path__ + "static/decima-mono-bd4730674f36927ef2abc7e74f992627.woff";